<div>
    <p class="custom-modal-heading">{{heading}}</p>
    <div class="custom-modal-actions">
        <button mat-flat-button color="warn" (click)="closeDialog()">Cancel</button>
        <button mat-flat-button color="primary" (click)="deleteDialog()">Delete</button>
    </div>
</div>